import Swal from "sweetalert2";
import { useAbm } from "../../../../services/abm";
import { useAbmContext } from "../../../../views/abm/useAbmComponent";
import { ActionButton } from "../../../helpers";
import { DeleteIcon } from "../../../icons";

export const EliminarFichaActividad = ({params}) => {
  const actividades = useAbm({entity: "actividades"});
  const { loadDetails } = useAbmContext();

  const handleClick = () => {
    Swal.fire({
      icon: "question",
      title: "Eliminar ficha",
      html: "Realmente desea eliminar la ficha de la actividad.<br/>Esta operación no podrá deshacerse.",
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Sí, eliminar permanentemente",
      denyButtonText: "Cancelar",
    }).then((result) => {
      if(!result.isConfirmed) return;

      actividades
        .remove("ficha", `actividades/${params.id}`)
        .then(() => loadDetails(params.id));
    });
  };

  return (
    <ActionButton
      iconButton
      enabled={true}
      Icon={DeleteIcon}
      htmlColor="var(--bs-danger)"
      onClick={handleClick}
    />
  );
};
